module.exports = __webpack_public_path__ + "static/media/paypal_color.c2202fd5.svg";